module.exports = __webpack_public_path__ + "static/media/foto8.f12e152a.jpg";